// src/data/amenitiesData.js

export const amenities = [
  { 
    id: 'hall', 
    name: 'Hall e Sala de TV', 
    images: [
      '/images/HotelSection/hall001.webp', 
      '/images/HotelSection/hall002.webp', 
      '/images/HotelSection/hall003.webp', 
      '/images/HotelSection/hall004.webp', 
      '/images/HotelSection/hall005.webp', 
      '/images/HotelSection/hall006.webp' 
    ],
    description: 'Nossos ambientes de convivência são um convite ao descanso. Relaxe em nosso elegante hall de entrada ou assista a um filme em nossa confortável sala de TV, equipada com poltronas aconchegantes.' 
  },
  { 
    id: 'restaurante', 
    name: 'Restaurante para Café da Manhã', 
    images: [
      '/images/HotelSection/cafe-da-manha001.webp',
      '/images/HotelSection/cafe-da-manha002.webp',
      '/images/HotelSection/cafe-da-manha003.webp',
      '/images/HotelSection/cafe-da-manha004.webp',
      '/images/HotelSection/cafe-da-manha005.webp',
      '/images/HotelSection/cafe-da-manha006.webp',
      '/images/HotelSection/cafe-da-manha007.webp',
      '/images/HotelSection/cafe-da-manha008.webp',
      '/images/HotelSection/cafe-da-manha009.webp',
      '/images/HotelSection/cafe-da-manha010.webp',
      '/images/HotelSection/cafe-da-manha011.webp',
      '/images/HotelSection/cafe-da-manha012.webp',
      '/images/HotelSection/cafe-da-manha013.webp',
      '/images/HotelSection/cafe-da-manha014.webp',
      '/images/HotelSection/cafe-da-manha015.webp',

    ], 
    description: 'Comece seu dia com o pé direito em nosso charmoso restaurante, onde servimos um delicioso e completo café da manhã, com as iguarias e o sabor autêntico de Minas Gerais.' 
  },
  { 
    id: 'sitio', 
    name: 'Sítio', 
    images: [
      '/images/HotelSection/sitio001.webp',
      '/images/HotelSection/sitio002.webp',
      '/images/HotelSection/sitio003.webp',
      '/images/HotelSection/sitio004.webp'
    ], 
    description: 'Conecte-se com a natureza em nosso sítio. Um espaço verde com ar puro, ideal para caminhadas e para se conectar com a natureza. Nosso sítio também é o local onde nossos queijos são produzidos e muitos dos nossos eventos também acontecem aqui!' 
  }
];